import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      icon: "success",
      title: "Request Received",
      text: "Password reset functionality will be available soon. Please contact support for manual assistance.",
      confirmButtonColor: "#809080",
    });
  };

  return (
    <div className="min-h-screen bg-[#fef8f5] flex items-center justify-center py-16 px-4">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg space-y-8">
        <Link
          to="/login"
          className="flex gap-x-2 items-center text-[#809080] hover:underline"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Login
        </Link>

        <div className="text-center">
          <h2 className="text-3xl font-serif font-bold text-[#7a6e5f]">
            Forgot Your Password?
          </h2>
          <p className="mt-2 text-[#7a6e5f] opacity-80 text-sm">
            Enter your email address below. We’ll send you instructions once this feature is active.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-[#7a6e5f]">
              Email address
            </label>
            <div className="mt-1 relative">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                placeholder="you@example.com"
                className="block w-full px-4 py-3 pl-12 border border-gray-300 rounded-md shadow-sm placeholder-[#cbbdaf] focus:ring-[#809080] focus:outline-none"
              />
              <Mail className="absolute left-4 top-3.5 h-5 w-5 text-[#cbbdaf]" />
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-[#7a6e5f] text-white py-3 rounded-md font-medium hover:bg-[#6a5e53] transition"
          >
            Request Reset Link
          </button>
        </form>
      </div>
    </div>
  );
}
